import React from 'react';
import './SidebarHeader.scss';
import Icon from '../icon/Icon';
import {i18n} from '../../i18n/i18n';

export interface SidebarHeaderProps {
  title: string;
  subtitle?: string;
  buttons?: SidebarHeaderButton[];
}

export interface SidebarHeaderButton {
  id: string;
  icon: string;
  title: string;
  onClick: () => void;
}

export function buildPopStackButton(onClick: () => void): SidebarHeaderButton {
  return {
    id:      'close',
    icon:    'fa-close',
    title:   i18n().global.popStackButtonLabel,
    onClick: onClick
  };
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({ title, subtitle, buttons }) => {
  return <div className="sidebar-header">
    <div className="sidebar-header__content">
      <div className="sidebar-header__title">{title}</div>
      {subtitle && <div className="sidebar-header__subtitle">{subtitle}</div>}
    </div>
    {buttons?.map((button) =>
        <button key={button.id}
                className={'sidebar-header__button ' + button.id}
                title={button.title}
                aria-label={button.title}
                onClick={() => button.onClick()}>
          <Icon category={button.icon}/>
        </button>
    )}
  </div>;
};

export default SidebarHeader;
